import React from "react";
import styles from "./tuvis-skeleton.module.scss";
import classnames from "classnames";
export const TuvisSkeleton: React.FC<{
  className?: string;
  height?: string;
  width?: string;
  borderRadius?: string;
  textLoader?: boolean;
  loading?: boolean;
  children?: React.ReactNode;
}> = ({ width, height, className, textLoader, loading, borderRadius, children }) => {
  return loading ? (
    <div
      className={classnames(styles.loading, { [styles.textLoader]: textLoader }, className)}
      style={{ height, width, borderRadius }}
      data-testid={"tuvis-skeleton"}
    ></div>
  ) : (
    <>{children}</>
  );
};
